import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { Typography, useMediaQuery } from '@mui/material';
import ArsCard from './ArsCard';
import cleaning from '../../assets/cleaning.png';
import csrandweee from '../../assets/csrandweee.png';
import dataerasureandsecurity from '../../assets/dataerasureandsecurity.png';
import fillincrf from '../../assets/fillincrf.png';
import globallogistik from '../../assets/globallogistik.png';
import operatingsystem from '../../assets/operatingsystem.png';
import optimalbuypack from '../../assets/optimalbuypack.png';
import qualitycheck from '../../assets/qualitycheck.png';
import registration from '../../assets/registration.png';
import reporting from '../../assets/reporting.png';
import sorting from '../../assets/sorting.png';
import production1 from '../../assets/production1.png';
import allProducts from '../../assets/allProducts.png';
import ArsCardNew from './ArsCardNew';

const arsCardData = [
    {
        haveLink: false, title: 'Optimal Buy-Back', description:
            'By choosing T1A you benefit from an expertise backed by 20 years of experience in the valuation and handling of used IT',
        imgUrl: optimalbuypack
    },
    {
        haveLink: false, title: 'Data Erasure and Security', description: 'Data erasure process is backed by ISO 27001 for Information Security Management. Each unit is data erased and the process is documented',
        imgUrl: dataerasureandsecurity
    },
    {
        haveLink: false, title: 'CSR and WEEE', description: 'With T1A you minimize electronic waste and overuse of natural resources. 99% of all IT equipment is refurbished or recycled for other manufacturing',
        imgUrl: csrandweee
    },
    {
        haveLink: false, title: 'Global Logistics', description: 'T1A has more than 20 years of experience in collaborating with global organisations. This gives T1A solid in-house logistic know-how',
        imgUrl: globallogistik
    }
];


const assetRecoveryProcessData = [
    {
        haveLink: true, title: 'Fill in CRF', description: `Choose a logistics solution when Contact Tier1 Asset's department of logistics if you need assistance: logistik@tier1asset.com`,
        imgUrl: fillincrf
    },
    {
        haveLink: true, title: 'Logistics', description: 'You benefit from global logistics. Tier1 Asset (T1A) coordinates the planning process for the pickup of goods for any global or local customer. For more details check out our packing instructions.',
        imgUrl: globallogistik
    },
    {
        haveLink: false, title: 'Registration', description: 'When the equipment arrives at Tier1 Asset, each unit is registered in the database.',
        imgUrl: registration
    },
    {
        haveLink: false, title: 'Sorting', description: 'The equipment is sorted and put into inventory. Any residual e-waste is sent to recycling.',
        imgUrl: sorting
    },
    {
        haveLink: false, title: 'Cleaning', description: 'Each unit is subject to manual removal of stickers and other types of physical marking.',
        imgUrl: cleaning
    },
    {
        haveLink: false, title: 'Data Erasure', description: 'The units undergo a GDPR compliant data erasure process. Any sensitive data is wiped completely from the device ensuring full anonymization.',
        imgUrl: dataerasureandsecurity
    },
    {
        haveLink: false, title: 'Quality Check', description: 'Performance and quality are checked. The staff grades the units based on their physical condition.',
        imgUrl: qualitycheck
    },
    {
        haveLink: false, title: 'Operating System', description: 'A genuine Microsoft Windows license is installed on each computer.',
        imgUrl: operatingsystem
    },
    {
        haveLink: false, title: 'Reporting', description: 'At the end of the process, you will receive a detailed unit-level report that shows each step the equipment has gone through in the Asset Recovery Process. It also proves that your equipment has been handled environmentally friendly.',
        imgUrl: reporting
    },
];

const HomePageComponent = () => {

    const mdMatch = useMediaQuery('(min-width:900px)');
    const lgMatch = useMediaQuery('(min-width:1200px)');

    const btn = true;
    const bigTitle = true;

    const iconWidthHeight = {
        m: '0 auto',
        color: '#fff',
        width: { xs: 80, lg: 80 },
        height: { xs: 80, lg: 80 },

    }

    const iconWidthHeightArsProcess = {
        p: 2,
        m: '0 auto',
        color: '#fff',
        width: { xs: 50, lg: 160 },
        height: { xs: 50, lg: 160 }
    }

    const fourBoxStyle = {
        height: 290,
        bgcolor: '#003755',
        width: 330,
        color: '#fff',
        mt: 3,
        p: '2px'
    }
    const nineBoxHeight = lgMatch ? 500 : 400;
    const nineBoxWidth = !mdMatch ? 330 : 150;

    const nineBoxStyle = {
        height: { nineBoxHeight },
        bgcolor: '#fff',
        width: { nineBoxWidth },
        borderRadius: '10px',
        m: '0 auto',
        p: 1,
    }

    const nineBoxSpacing = lgMatch ? 4 : 2;

    return (
        <Box sx={{ flexGrow: 1 }}>
            <Grid container sx={{ height: { lg: 800, md: 1500 }, mt: 11, bgcolor: '#000', overflow: 'hidden' }}>
                <Grid item xs={12} sm={12} md={12} lg={6} xl={6} sx={{ mt: 4}}>
                    <Typography variant={!mdMatch ? 'body1' : 'h4'} textAlign={'center'} color='#fff'>
                        Asset Recovery Service</Typography>
                    <Box component={'div'}
                        sx={{
                            display: 'flex',
                            flexFlow: 'row wrap',
                            justifyContent: 'space-evenly',
                            alignItems: "center",
                            p: '2px',
                            maxWidth: 790,
                            margin: '0 auto'
                        }}>
                        {arsCardData.map((data, index) => (
                            <ArsCardNew key={data.title}
                                haveLink={data.haveLink} imgUrl={data.imgUrl} title={data.title}
                                description={data.description} boxStyle={fourBoxStyle} index={index}
                                iconWidthHeight={iconWidthHeight}
                            />
                        ))}
                    </Box>
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                    {lgMatch ?
                        <img src={production1} alt='Production' className='image' />
                        :
                        <Box sx={{ width: '90%', margin: '10px auto' }}>
                            <img src={production1} alt='Production' className='image' />
                        </Box>
                    }
                </Grid>
            </Grid>
            <Grid container spacing={1} sx={{ height: { lg: 600, md: 1000 } }}
                direction="row"
                justifyContent="center"
                alignItems="flex-start"
            >
                <Grid item xs={12} lg={6}>
                    <img src={allProducts} alt='Production' className='image' />
                </Grid>
                <Grid item xs={12} lg={6} sx={{ mt: 4 }}>
                    <Box component={'div'} sx={{
                        bgcolor: '#47b97d', color: '#fff', borderRadius: '40px', height: 30, width: 150,
                        margin: { xs: '0 auto', lg: '0 0 0 30px' },

                    }}
                    >
                        <Typography variant='body1' textAlign='center' sx={{ p: 0.5 }}>
                            Tier1Asset</Typography>
                    </Box>
                    <Box component={'div'} sx={{ maxWidth: 525, p: 4, margin: { xs: '0 auto', lg: 0 } }}>
                        <Typography variant={!mdMatch ? 'h5' : 'h4'} textAlign={'left'}>
                            <strong>EUROPE'S LEADING REFURBISHER</strong>
                        </Typography>
                        <Typography variant={!mdMatch ? 'h6' : 'h5'} paragraph textAlign={'left'} sx={{ pt: 2 }}>
                            IT equipment for companies and users seeking a more sustainable IT infrastructure
                        </Typography>
                        <Typography variant='body1' paragraph textAlign={'left'} sx={{ pt: 2 }}>
                            T1A is Europe’s leading refurbisher with more than 4000 m² production and warehouse facilities with
                            20 years of experience. We take great pride in our strict grading policy, and are Blancco certified Gold Partner
                            and Microsoft authorized refurbisher. Prior to any sales, our products go through rigorous testing to make sure that our customers receive only 100% fully functioning products with zero to minimal signs of usage.
                        </Typography>
                    </Box>
                </Grid>
            </Grid>
            <Box component='div'
                sx={{
                    bgcolor: '#000',
                    width: '100%', position: 'relative',
                    margin: { md: '70px auto', lg: '0 auto' }
                }}>
                <Box component={'div'} alignItems='center'
                    sx={{
                        bgcolor: '#000',
                        height: { lg: 350, xs: 250 }, width: '100%',
                    }}>
                    <Box component={'div'} sx={{ width: { xs: 400, md: 700 }, m: '0 auto', p: { xs: 2, md: 6 } }}>
                        <Typography variant={lgMatch ? 'h2' : 'h5'} textAlign={'center'} sx={{ pt: 1, color: '#fff' }}>
                            Asset Recovery Process </Typography>
                    </Box>
                </Box>
                <Box component={'div'}
                    sx={{
                        bgcolor: '#003755',
                        height: {
                            lg: ((nineBoxHeight * 3) + (nineBoxSpacing * 2 * 16) - 600),
                            // lg: ((nineBoxHeight * 3) + (nineBoxSpacing * 2 * 16) - 290),
                            // md: ((nineBoxHeight * 5) + (nineBoxSpacing * 4 * 16) - 350),
                            // sm: ((nineBoxHeight * 9) + (nineBoxSpacing * 8 * 16) - 530),
                            // xs: ((nineBoxHeight * 9) + (nineBoxSpacing * 8 * 16) - 480),
                            md: ((nineBoxHeight * 5) + (nineBoxSpacing * 4 * 16) - 660),
                            sm: ((nineBoxHeight * 9) + (nineBoxSpacing * 8 * 16) - 1150),
                            xs: ((nineBoxHeight * 9) + (nineBoxSpacing * 8 * 16) - 1090),
                        },
                        width: '100%'
                    }}>
                </Box>
                <Box component={'div'}
                    sx={{
                        bgcolor: '#000',
                        height: { lg: 300, xs: 200 }, width: '100%'
                    }}>
                </Box>
                <Box component={'div'}
                    sx={{
                        position: 'absolute', top: { xs: 150, sm: 140, md: 130, lg: 180 },
                        right: { xs: 10, lg: 180 }, left: { xs: 10, lg: 180 }
                    }}>
                    <Grid container
                        direction="row"
                        justifyContent="center"
                        alignItems="center"
                        spacing={nineBoxSpacing} sx={{ p: { sm: 0, md: 2 }, width: { lg: 1200, md: 780, sm: 400, xs: 300 }, m: '0 auto' }} >
                        {assetRecoveryProcessData.map((data, index) => (
                            <Grid item xs={12} md={6} lg={4} key={data.title}
                            >
                                <ArsCard haveLink={data.haveLink} imgUrl={data.imgUrl} title={data.title}
                                    description={data.description} boxStyle={nineBoxStyle} index={index}
                                    iconWidthHeight={iconWidthHeightArsProcess} btn={btn} bigTitle={bigTitle} />
                            </Grid>
                        ))}
                    </Grid>
                </Box>
            </Box>
        </Box>
    );
}
export default HomePageComponent;